<template>
  <v-dialog v-model="isImageOpen" scrollable persistent max-width="600">
    <v-card>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-image-outline</v-icon
          >{{
            $vuetify.lang.t(
              "$vuetify.courseManagement.liveStep.addLiveDialog.addImage"
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="clearData">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <p class="body-1 font-weight-medium mb-0">
          {{
            $vuetify.lang.t(
              "$vuetify.courseManagement.liveStep.addLiveDialog.uploadImage"
            )
          }}
        </p>
        <v-row>
          <v-col cols="12" lg="4" class="pt-5">
            <div class="upload-btn-wrapper">
              <button class="upload-image-button body-1 font-weight-light">
                {{
                  $vuetify.lang.t(
                    "$vuetify.courseManagement.liveStep.addLiveDialog.chooseImage"
                  )
                }}
              </button>
              <input
                type="file"
                name="myfile"
                multiple
                accept="image/x-png, image/jpeg"
                @change="selectFile"
              />
            </div>
          </v-col>
          <!-- <v-col cols="12" lg="8">
            <div class="progressContainer">
              <p class="mb-0 body-2 font-weight-regular">Upload Status</p>
              <p class="mb-0 caption">{{progressPercent}}%</p>
            </div>
          </v-col> -->
        </v-row>

        <div class="img-list-preview">
          <div v-for="(src, index) in imgSrc" :key="index + '_' + src">
            <v-row class="d-flex">
              <v-col cols="4" :lg="4" :md="4" :sm="4">
                <div class="img-panel">
                  <v-img
                    height="145px"
                    :src="src.src"
                    :lazy-src="src.src"
                    contain
                    aspect-ratio="1"
                  />
                </div>
              </v-col>
              <v-col cols="8" :lg="8" :md="8" :sm="8">
                <v-row>
                  <v-col cols="10" class="py-0">
                    <p class="my-0">{{ src.name }}</p>
                  </v-col>
                  <v-col cols="2" class="py-0 text-center">
                    <v-btn icon small @click="removeRow(index)">
                      <v-icon size="20">mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="showUploadPercent">
                  <v-col cols="12" class="d-flex py-0">
                    <v-progress-linear
                      class="progress mt-2 mr-4"
                      :value="src.progressPercent"
                      reactive
                      height="10"
                    ></v-progress-linear>
                    <p class="mb-0">{{ src.progressPercent }}%</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>

        <v-divider class="my-5"></v-divider>

        <v-row>
          <v-col class="text-right">
            <v-btn
              elevation="0"
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              @click="clearData"
              >{{
                $vuetify.lang.t(
                  "$vuetify.courseManagement.liveStep.addLiveDialog.cancel"
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary white--text"
              @click="validate"
              :loading="loadingBtn"
              :disabled="imgFile.length == 0"
              >{{
                $vuetify.lang.t(
                  "$vuetify.courseManagement.liveStep.addLiveDialog.save"
                )
              }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { insertImage } from "@/service/course/livev2";
import { headersWithTokenForImage, domain } from "@/service/configApi";
import axios from "axios";
export default {
  props: {
    isImageOpen: {
      type: Boolean,
    },
    isImageClose: {
      type: Function,
    },
    idLive: {
      type: String,
    },
  },
  data: () => ({
    nameRules: [(v) => !!v || "Name is required"],
    // progressPercent: [],
    showUploadPercent: false,
    imgSrc: [],
    imgFile: [],
    imgUploadId: [],
    loadingBtn: false,
  }),
  methods: {
    removeRow: function (index) {
      this.imgFile.splice(index, 1);
      this.imgSrc.splice(index, 1);
    },
    async clearData() {
      this.progressPercent = [];
      this.showUploadPercent = false;
      this.percent = [];
      this.imgSrc = [];
      this.imgFile = [];
      this.imgUploadId = [];
      this.successStatus = false;
      await this.isImageClose();
    },
    async selectFile(event) {
      let totalFiles = event.target.files.length;

      for (var i = 0; i < totalFiles; i++) {
        let file = event.target.files[i];
        this.imgFile.push(file);
        // this.progressPercent.push(0);
        this.imgSrc.push({
          name: file.name,
          src: await URL.createObjectURL(file),
          progressPercent: 0,
        });
      }

    },
    updateProgress(index, percent) {
      this.imgSrc[index].progressPercent = percent;
    },
    async validate() {
      this.loadingBtn = true
      for (let i = 0; i < this.imgFile.length; i++) {
        const file = this.imgFile[i];
        this.showUploadPercent = true;

        let formData = new FormData();
        formData.append("fileupload", file);
        formData.append("title", file.name);
        await axios
          .post(`${domain}/uploadfile/public/image/livev2`, formData, {
            headers: {
              ...headersWithTokenForImage(),
            },
            onUploadProgress: function (progressEvent) {
              let percent = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
              this.updateProgress(i, percent);
            }.bind(this),
          })
          .then(
            async function (response) {

              await insertImage(this.idLive, {
                priority: 1,
                title: file.name,
                description: "add by web",
                img: response.data.result,
              });
              
            }.bind(this)
          )
          .catch(function (e) {
          });
      }
      await this.clearData();
      this.loadingBtn = false
    },
  },
};
</script>
<style lang="scss">
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
}

.btn-choose {
  color: white;
  background-color: #1976d2;
  padding: 8px 20px;
  border-radius: 5px;
  text-transform: unset;
  width: 100%;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  &:hover {
    cursor: pointer;
  }
}
.exampleimg {
  /* height: 450px; */
  text-align: left;
}
.iframeimg {
  width: 100%;
  border: 1px dashed #e9e9e9;
  background: #fbfbfb;
}
.theme--light.v-file-input .v-file-input__text--placeholder {
  color: white !important;
  font-size: 18px;
  text-align: center;
}
.img-panel {
  width: 100%;
  border: 2px dashed #e9e9e9;
  background: #f3f0f0;
}

.upload-image-button {
  border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  padding: 8px 20px;
  font-size: 16px;
  width: 100%;
  /* color: rgb(65, 65, 65); */
  border: 1px solid rgb(195, 195, 195);
}
</style>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
</style>
